/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRemoteDto } from "./i-remote-dto";
import { DirectoryRestrictionFilterRemoteDto } from "./directory-restriction-filter-remote-dto";
import { EmailTemplateShortInfoRemoteDto } from "./email-template-short-info-remote-dto";

export class SkillConfigurationRemoteDto implements IRemoteDto {
    id: number;
    skillType: number;
    skillName: string;
    originName: string;
    skillColor: string;
    agentParkColor: string;
    skillParkColor: string;
    skillUrl: string;
    skillUrlConnected: string;
    skillUrlConnectedOutbound: string;
    skillUrlDisconnected: string;
    skillUrlRefresh: string;
    skillUrlRingback: string;
    skillUrlStartup: string;
    isShared: boolean;
    directoryAssociations: DirectoryRestrictionFilterRemoteDto[] = [];
    emailConnectorId: number;
    defaultTemplateId: number;
    skillEmail: string;
    emailTemplates: EmailTemplateShortInfoRemoteDto[] = [];
    hasRecordingAnnouncement: boolean;
    categories: string[] = [];
    informWaitingItem: boolean;
}
